import React, {Component} from "react";

import axios from 'axios';
import history from '../../../history';
import Constants from '../../../components/Constants/';
import {
    Row,
    Col,
    Button,
    Label,
    Input,
    Link,
    Table,
    Badge
} from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import AlertContainer from 'react-alert';

class GroupList extends Component {

  constructor(props) {
    super(props);

    this.refreshGroupsList = this.refreshGroupsList.bind(this);

    this.state = {
        groupsList: null,
        activePage: 1
      };

      /*
      * Configurações do alerta
      */
      this.alertOptions = {
        offset: 14,
        position: 'top right',
        theme: 'light',
        time: 10000,
        transition: 'scale'
      }

      this.refreshGroupsList();
    }

    refreshGroupsList(){
      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/group'
      })
      .then(response => {
          this.setState({
              groupsList: response.data
          });
      });
    }

    statusFormatter(cell, row){
      return (
        cell == "ACTIVE" ? <Badge color="success">Ativo</Badge> : <Badge color="danger">Inativo</Badge>
      );
    }

    actionsFormatter(cell, row){
      return (
        <Button color="info" onClick={() => { history.replace("/group/"+cell); }}><i className="fa fa-pencil fa-inverse"></i></Button>
      );
    }

    renderPaginationShowsTotal(start, to, total) {
      return (
        <p>
          Exibindo de { start } a { to }, total: { total }
        </p>
      );
    }

    render() {
      if(this.state.groupsList == null) return null;

      const tableOptions = {
        paginationSize: 10,
        hideSizePerPage: true,
        paginationShowsTotal: true,
        paginationShowsTotal: this.renderPaginationShowsTotal
      };

      const statusTypes = [ {
        value: 'ACTIVE',
        text: 'Ativo'
      }, {
        value: 'INACTIVE',
        text: 'Inativo'
      }];

      return(
          <div>
            <h2>Grupos</h2>
            <hr />

            <Button color="success" onClick={() => { history.replace("/group"); }}>
              <i className="fa fa-plus fa-inverse"></i>
              {'\u00A0'}
              Adicionar Grupo
            </Button>
            <br />

            <BootstrapTable ref="table" data={this.state.groupsList} version='4'
              striped hover pagination search searchPlaceholder='Pesquisa Geral'
              options={tableOptions} >
              <TableHeaderColumn dataField="name" dataSort={true} width='50%'>Nome</TableHeaderColumn>
              <TableHeaderColumn dataField="code" dataSort={true} width='20%'>Código</TableHeaderColumn>
              <TableHeaderColumn dataField="id" isKey={true} dataFormat={this.actionsFormatter} width='20%'><i className="fa fa-cog"></i></TableHeaderColumn>

            </BootstrapTable>
            <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
            <br />
          </div>
        )
    }
}

export default GroupList;



// WEBPACK FOOTER //
// ./src/views/admin/GroupList/GroupList.js